import React, { useState } from "react";
import PrivacyPolicyModal from "./PrivacyPolicyModal";

const Footer = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);

  return (
    <footer className="simple-footer">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-12">
            <div className="footer-social-icons">
              <a
                href="https://linkedin.com/company/ncg-corporate"
                aria-label="LinkedIn"
              >
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a
                href="https://instagram.com/ncgcorporate"
                aria-label="Instagram"
              >
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://youtube.com/@ncgcorporate" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
              <a href="https://twitter.com/ncgcorporate" aria-label="Twitter">
                <i className="fab fa-x-twitter"></i>
              </a>
              <a href="https://facebook.com/ncgcorporate" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Second row: Company info and legal links */}
        <div className="row align-items-center mt-3">
          <div className="col-12 col-lg-6 col-md-6">
            <div className="footer-company-info">
              <h6>NCG Corporate</h6>
              <p>&copy; 2024 - 2025</p>
            </div>
          </div>

          <div className="col-12 col-lg-6 col-md-6">
            <div className="footer-links">
              <a href="/accessibility">Accessibility Policy</a>
              <a href="/terms">Terms of Use</a>
              <button
                type="button"
                className="footer-legal-trigger"
                onClick={() => setPrivacyOpen(true)}
              >
                Privacy Policy
              </button>
              <a href="/cookies">Cookie Notice</a>
            </div>
          </div>
        </div>
      </div>

      <PrivacyPolicyModal
        isOpen={privacyOpen}
        onClose={() => setPrivacyOpen(false)}
      />
    </footer>
  );
};

export default Footer;
